import React from 'react'
import { tooltip } from './Modal'
import Cookies from 'js-cookie'

export function isGuest({ showTooltip } = {}) {
  if (!Cookies.get('insta_access_token')) {
    if (showTooltip) {
      tooltip({ content: __['app.points.common.login_text'] })
    }
    return true
  } else {
    return false
  }
}

export default class Block extends React.Component {
  componentDidMount() {
    isGuest({ showTooltip: true })
  }

  render() {
    return this.props.children
  }
}
